import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import * as REGISTRATION_CONFIGURATION_API from '../../constants/api/registration-configuration';
import { IFormRegistrationConfigurationDTO, IGeneralRegistrationDTO, IRegistrationConfigurationDAO } from '../registration-configuration.dao';
import { GetCustomFieldsOptionsList } from '../custom-pages.dao';
import { IEventRequestParams } from '../shared.dto';

class RegistrationConfigurationDAO extends IRegistrationConfigurationDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getRegistrationConfiguration(eventId: number, accountId: number): Promise<IGeneralRegistrationDTO> {
        const response = await this.apiClient.get<Promise<IGeneralRegistrationDTO>>(REGISTRATION_CONFIGURATION_API.GENERAL_REGISTRATION_CONFIGURATION, {
            accountId: accountId,
            eventId: eventId
        });

        return response.parsedResponse;
    }


    public async updateRegistrationConfiguration(accountId: number, eventId: number, registrationConfiguration: IGeneralRegistrationDTO)
        : Promise<IGeneralRegistrationDTO> {
        const response = await this.apiClient.put<Promise<IGeneralRegistrationDTO>>(REGISTRATION_CONFIGURATION_API.GENERAL_REGISTRATION_CONFIGURATION, {
            accountId: accountId,
            eventId: eventId,
            ...registrationConfiguration
        });
        return response.parsedResponse;
    }

    public async getFormRegistrationConfiguration(eventId: number, accountId: number): Promise<IFormRegistrationConfigurationDTO> {
        const response = await this.apiClient.get<Promise<IFormRegistrationConfigurationDTO>>(REGISTRATION_CONFIGURATION_API.FORM_REGISTRATION_CONFIGURATION, {
            accountId: accountId,
            eventId: eventId
        });

        return response.parsedResponse;
    }

    public async updateFormRegistrationConfiguration(accountId: number, eventId: number, registrationConfiguration: IFormRegistrationConfigurationDTO)
        : Promise<IFormRegistrationConfigurationDTO> {
        const response = await this.apiClient.put<Promise<IFormRegistrationConfigurationDTO>>(REGISTRATION_CONFIGURATION_API.FORM_REGISTRATION_CONFIGURATION, {
            accountId: accountId,
            eventId: eventId,
            ...registrationConfiguration
        });
        return response.parsedResponse;
    }

    public async getCustomFieldsOptionsList(eventId: number, accountId: number): Promise<GetCustomFieldsOptionsList> {
        const response = await this.apiClient.get<GetCustomFieldsOptionsList>(
            REGISTRATION_CONFIGURATION_API.CUSTOM_FIELDS_OPTIONS_LIST,
            {
                eventId: eventId,
                accountId: accountId
            }
        );
        return response.parsedResponse;
    }

    public async deleteCustomeField(params: IEventRequestParams & {
        customFieldId: number;
    }): Promise<void> {
        const response = await this.apiClient.delete<void>(
            REGISTRATION_CONFIGURATION_API.DELETE_CUSTOME_FIELD,
            params
        );
        return response.parsedResponse;
    }
}

export { RegistrationConfigurationDAO };